module.exports = {
    title: {
        en: "IMP Stratford",
        cy: "Ymgynghoriad sefydlog",
    },

    description: {
        en: "",
        cy: "Welsh Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas mattis tempus est, vel ornare mi posuere in."
    },

    socialImage: "/assets/images/social-image.jpg",



    email: "info@construction.stratford46.com"
}